module.exports = {"id":"176605","name":"Pablo Armero","rating":"75","photo":"./data/images/photos/1/176605.png","club":{"name":"América de Cali","logo":"./data/images/clubs/AmericadeCali.png"},"positions":["DG","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PabloArmero0.json
// module id = 3338
// module chunks = 0